import { render, staticRenderFns } from "./WorkflowDetails.vue?vue&type=template&id=5913b644&scoped=true&"
import script from "./WorkflowDetails.vue?vue&type=script&lang=js&"
export * from "./WorkflowDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowDetails.vue?vue&type=style&index=0&id=5913b644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5913b644",
  null
  
)

export default component.exports